// -- ACH Enrollments -- //
export const ACH_ENROLLMENT_HEADER_TXT = "ACH Payment Enrollment";

export const ACH_ENROLLMENT_STEPS_LABEL = {
  Authentication: "Authentication",
  CompanyInfo: "Confirm Company Info",
  SelectBuyers: "Select Buyers",
  PaymentDetails: "Payment Details",
};

export const ACH_DYNAMIC_COMPONENTS = {
  Authentication: "Authentication",
  CompanyInfo: "CompanyInfo",
  SelectBuyers: "SelectBuyers",
  PaymentDetails: "PaymentDetails",
};

// prettier-ignore
export const ACH_AUTHENTICATION = {
  EmailZipInfo: "Fill in the email address that received the enrollment invite and the zip code of your company address.",
  EmailHelperTxt: "Use email address from enrollment invite.",

  EmailAddresLabel: "Email Address",
  ZipCodeLabel: "Company Zip Code",
  AccessCodeLabel: "8-digit Access Code",

  EnterEmailAddress: "Enter Email Address",
  InvalidEmailAddress: "This is not a valid email address",
  InvalidEmailAddressHelper:"Email Address should not be blank or in invalid format",

  EnterZipCode: "Enter Company Zip Code",
  InvalidZipCodeHelper:"Invalid format. Please enter a five-digit number.",

  EnterAccessCode: "Enter Access Code",
  InvalidAccessCode: "Access Code should not be blank or in invalid format",
  AccessCodeInfo: "The code may take up to 3-5 minutes to appear in the inbox",
};

export const COMPANY_INFO = {
  Heading: "Please review information below to begin your profile creation.",
  BannerInfo: `If any details are incorrect, please <a class='text-customBlueDark underline' href='mailto:jpmc@jpmc.com'> 'Contact Us' </a>  and we will assist you with the sign up process.`,
};
export const SELECT_BUYERS = {
  SubHeading: "Please choose the buyers you want to switch to ACH.",
  AvailableBuyers: "Available Buyer(s)",
};

export const COMPANY_INFO_LABEL = {
  CompanyName: "Company Name",
  Street: "Street Address",
  City: "City",
  StateProvince: "Province/State",
  ZipCode: "Zipcode",
  Country: "Country",
};

export const PAYMENT_DETAILS = {
  // prettier-ignore
  BannerInfo: "Please complete this enrollment to avoid losing any unsaved progress. Do not navigate back or refresh this page.",
  HeadingText:
    "Please complete the required forms for all the buyers you have selected. All information entered will be sent securely to the  J.P. Morgan supplier enablement team.",

  PayeeInfoHeading: "Payee Information",
  AccountInfoHeading: "Account Information",
};

export const USD_CURRENCY = "USD";
export const USA_COUNTRY = "United States of America";

export const CHECKING_ACCOUNT = "Checking Account";
export const SAVINGS_ACCOUNT = "Savings Account";

export const PAYMENT_AUTHORIZATION_INPUTS = {
  Name: { Label: "Name" },
  EmailAddress: { Label: "Email Address" },
  PhoneNumber: {
    Label: "Phone Number",
    HelperText: "Enter Mobile Number in XXX-XXX-XXXX format",
  },
};

export const AUTHORIZATION_FORM_INPUTS = {
  name: "name",
  emailAddress: "emailAddress",
  phoneNumber: "phoneNumber",
};

export const PAYMENT_AUTHORIZATION_VALIDATION_MESSAGE = {
  [AUTHORIZATION_FORM_INPUTS.name]: {
    emptyMsg: "Name is required",
    invalidFormatMsg: "Name should not exceed 40 characters",
  },
  [AUTHORIZATION_FORM_INPUTS.emailAddress]: {
    emptyMsg: "Email Address is required",
    invalidFormatMsg: "Email Address is in invalid format",
  },
  [AUTHORIZATION_FORM_INPUTS.phoneNumber]: {
    emptyMsg: "Phone Number is required",
    invalidFormatMsg: "Phone number should be in valid format",
  },
};

export const PHONE_NUMBER_MAX_LENGTH = 13;
export const PHONE_NUMBER_MIN_LENGTH = 10;
export const ONLY_NUMERIC_REGEX = /^\d+$/;

export const PAYMENT_DETAILS_INPUTS = {
  TaxPayerId: { Label: "Taxpayer ID (TIN) or SSN" },

  EmailAddres: {
    Label: "Email Address for Remittance Advice",
    HelperTxt: "Email address for payment notification.",
  },

  AccountType: {
    Label: "Type of Account",
    Options: [CHECKING_ACCOUNT, SAVINGS_ACCOUNT],
  },

  FinancialInstituteName: { Label: "Financial Institution Name" },
  AccountCurrency: { Label: "Account Currency" },

  FinancialInstAddress: {
    Label: "Financial Institution Address",
    HelperText: "Number and Street",
  },

  FinancialInstCity: { Label: "City" },
  State: { Label: "State" },
  ZipCode: { Label: "Zipcode" },
  Country: { Label: "Country", Value: USA_COUNTRY },

  AccountName: { Label: "Account Name" },
  RoutingNumber: {
    Label: "Routing Number (ABA) / Swift Code",
    HelperText: "9 digit",
  },

  AccountNumber: { Label: "Account Number" },
  ConfirmAccountNum: {
    Label: "Confirm Account Number",
    HelperText: "Please manually enter your account number to ensure accuracy",
  },

  CopyCheckBox: {
    Label: "Use this information for all buyers",
  },
};

export const BUYER_FORM_INPUTS = {
  name: "name",
  supplierAddress: "supplierAddress",
  supplierCity: "supplierCity",
  supplierState: "supplierState",
  supplierZipcode: "supplierZipcode",
  taxPayerId: "taxPayerId",
  emailAddress: "emailAddress",
  financialInstituteName: "financialInstituteName",
  financialInstituteAddress: "financialInstituteAddress",
  country: "country",
  accountCurrency: "accountCurrency",
  typeOfAccount: "typeOfAccount",
  city: "city",
  state: "state",
  zipCode: "zipCode",
  accountName: "accountName",
  routingNumber: "routingNumber",
  accountNumber: "accountNumber",
  confirmAccountNumber: "confirmAccountNumber",
};

export const PAYMENT_DETAILS_VALIDATION_MESSAGE = {
  [BUYER_FORM_INPUTS.name]: {
    emptyMsg: "Company name is required",
    invalidFormatMsg:
      "Please provide a valid company name : must be under 100 character",
  },
  [BUYER_FORM_INPUTS.supplierAddress]: {
    emptyMsg: "Remittance Address is required",
    invalidFormatMsg:
      "Please provide a valid Remittance Address : must be under 100 character",
  },
  [BUYER_FORM_INPUTS.supplierCity]: {
    emptyMsg: "City is required",
    invalidFormatMsg:
      "Please provide a valid city  : must be under 50 character",
  },
  [BUYER_FORM_INPUTS.supplierState]: {
    emptyMsg: "State is required",
    invalidFormatMsg: "",
  },
  [BUYER_FORM_INPUTS.supplierZipcode]: {
    emptyMsg: "Zipcode is required",
    invalidFormatMsg: "Please provide a valid Zipcode",
  },
  [BUYER_FORM_INPUTS.taxPayerId]: {
    emptyMsg: "Taxpayer Id is required",
    invalidFormatMsg:
      "Please enter a valid Taxpayer Id or SSN : should be 9 digits",
  },
  [BUYER_FORM_INPUTS.emailAddress]: {
    emptyMsg: "Email Address is required",
    invalidFormatMsg: "Email Address is in invalid format",
  },
  [BUYER_FORM_INPUTS.financialInstituteName]: {
    emptyMsg: "Financial Institution Name is required",
    invalidFormatMsg:
      "Financial Institution Name should not exceed 100 characters",
  },
  [BUYER_FORM_INPUTS.financialInstituteAddress]: {
    emptyMsg: "Financial Institution Address is required",
    invalidFormatMsg:
      "Financial Institution Address should not exceed 256 characters",
  },
  [BUYER_FORM_INPUTS.country]: { emptyMsg: "", invalidFormatMsg: "" },
  [BUYER_FORM_INPUTS.accountCurrency]: { emptyMsg: "", invalidFormatMsg: "" },
  [BUYER_FORM_INPUTS.typeOfAccount]: {
    emptyMsg: "Account type is required",
    invalidFormatMsg: "Please enter a valid Account type",
  },
  [BUYER_FORM_INPUTS.city]: {
    emptyMsg: "City is required",
    invalidFormatMsg:
      "Please provide a valid city  : must be under 50 character",
  },
  [BUYER_FORM_INPUTS.state]: {
    emptyMsg: "State is required",
    invalidFormatMsg: "",
  },
  [BUYER_FORM_INPUTS.zipCode]: {
    emptyMsg: "Zipcode is required",
    invalidFormatMsg: "Please provide a valid Zipcode",
  },
  [BUYER_FORM_INPUTS.accountName]: {
    emptyMsg: "Account Name is required",
    invalidFormatMsg: "",
  },
  [BUYER_FORM_INPUTS.routingNumber]: {
    emptyMsg: "Routing Number is required",
    invalidFormatMsg: "Please enter a valid Routing / ABA number",
  },
  [BUYER_FORM_INPUTS.accountNumber]: {
    emptyMsg: "Account Number is required",
    invalidFormatMsg: "Please enter a valid Account number",
  },
  [BUYER_FORM_INPUTS.confirmAccountNumber]: {
    emptyMsg: "Confirm Account Number is required",
    invalidFormatMsg: "The numbers do not match. Please try again.",
  },
};

export const ACH_ENROLLMENT_STATUS = {
  Success: "SUCCESS",
  PartialSuccess: "PARTIAL SUCCESS",
};

// prettier-ignore
export const HAS_INVALID_SPECIAL_CHARS = "Valid characters include A-z, 0-9, and (.-',&)";
// prettier-ignore
export const HAS_INVALID_CITY_SPECIAL_CHARS = "Valid characters include A-z, space";

export const PAYMENT_DETAILS_ALPHA_NUMERIC_FIELDS = [
  BUYER_FORM_INPUTS.financialInstituteName,
  BUYER_FORM_INPUTS.financialInstituteAddress,
  BUYER_FORM_INPUTS.accountName,
];

export const AUTHORIZATION_DETAILS_ALPHA_NUMERIC_FIELDS = [
  AUTHORIZATION_FORM_INPUTS.name,
];

// -- common constants -- //

export const ACCESS_CODE_MAX_LENGTH = 8;
export const ZIP_CODE_MAX_LENGTH = 8;
export const WRONG_OTP_ATTEMPTS_ALLOWED = 3;

export const STEP_TRACKER = {
  ContinueBtn: "Continue",
  ConfirmContinue: "Confirm and Continue",
  VefifyBtn: "Verify",
  BackBtn: "Back",
  Submit: "Submit",
};

export const STEP_TRACKER_STATUS = {
  Completed: "completed",
  Default: "default",
};

export const STEP_PROGRESS = {
  CompletedOne: 1,
  CompletedTwo: 2,
  CompletedThree: 3,
  CompletedFour: 4,

  PendingOne: 1,
  PendingTwo: 2,
  PendingThree: 3,
  PendingFour: 4,
};

// prettier-ignore
export const SPINNER_TEXT = {
  Default: "Your input is being processed, please don't close or refresh this page.",
  Submission: "Submission in progress, please don't close or refresh this page."
}

export const EXISTING_SESSION = {
  Heading_1:"Multiple Active Sessions Detected",
  Heading_2:"Please continue with your previous session to complete your enrollment.",
  Text_Description:"If you wish to start a new session, please wait 25 minutes before trying the link again. Thank you for your cooperation."

}

export const STEP_TRACKER_DEFAULT_STATUS = new Array(4).fill(STEP_TRACKER_STATUS.Default);

export const VALID_REGX = {
  Email: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z]{2,}$/,
  ZipCode: /^\d{5,8}$/,
  City: /^[A-Za-z]+(?:\s[A-Za-z]+)*$/,
  AccessCode: /^\d{8}$/,
  AllowedSpecialChars: /^[a-zA-Z0-9 \-',&.]+$/,
};

export const INITIAL_AUTH_SCREENS = { showEmail: false, showAccessCode: false };

export const REMOVE_AUTOFILL_WARNING_DIALOG = {
  Heading: "Removing Payment Details Autofill",
  ContentTitle: "Unselecting this option will remove the autofilled payment details for other buyers. You'll need to enter them separately.",
  BtnLabelCancel: "Cancel",
  BtnLabelContinue:"Continue to Remove",
};